import Logo from "../../assets/LogoPrincipal.png";
import Input from "../../components/Input/Input";
import Filler from "../../assets/Filler.jpeg";
import styles from "./NewPassword.module.css";
import {FormEvent, useState} from "react";
import {jwtDecode} from "jwt-decode";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import api from "../../utils/axios/api";

// path: "/nova-sennha"

function NewPassword() {
  const { t } = useTranslation();
  const [newPassword, setNewPassword] = useState('')
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('')
  const [paramQuery,] = useSearchParams()
  const token = paramQuery.get('token')

  const navigate = useNavigate()

  const handleNewPassword = async (evt: FormEvent) => {
    evt.preventDefault()
    if (newPassword !== newPasswordConfirm) {
      alert('As senhas devem ser iguais!')
      return
    }
    
    if (!token) {
      return navigate('/login')
    }

    const { email } = jwtDecode(token) as {
      email: string
    }
    
    try {
      const response = await api.put('/user/resetPassword', {
        email,
        password: newPassword,
        token
      })
      console.log(response)

      navigate('/login')
    } catch (error) {
      alert('Erro ao alterar senha.')
    }
  }

  return (
    <div className={styles.body}>

      <form onSubmit={handleNewPassword} className={styles.container}>
        <img src={Logo} className={styles.Logo} />


        <div className={styles.title}>
          <div className={styles.wrapperTop}>
            <a href="/login">{t('EsqueciSenha.voltar')}</a>
          </div>
          <p className={styles.esqueci}>{t('EsqueciSenha.senha')}</p>
          <p className={styles.inserir}>{t('EsqueciSenha.crie')}</p>
        </div>

        <div className={styles.wrapperInput}>
          <Input label={t('EsqueciSenha.novasenha')} placeholder={t('EsqueciSenha.placeholder')} type="password" aoAlterado={(valor) => setNewPassword(valor)} />
          <Input label={t('EsqueciSenha.novamente')} placeholder={t('EsqueciSenha.placeholder')} type="password" aoAlterado={(valor) => setNewPasswordConfirm(valor)} />
        </div>

        <button type="submit" className={styles.button}>{t('EsqueciSenha.finalizar')}</button>
      </form>

      <img src={Filler} className={styles.filler} />
    </div>
  )
}

export default NewPassword